import { diContainer, serviceNames } from '../diContainer/diContainer';
import BillingRepository from '../repositories/BillingRepository';
import ShippingRepository from '../repositories/ShippingRepository';
import Address from '../domain/entities/Address';
import AnalyticsRepository from '../repositories/AnalyticsRepository';
import { ADDRESS_TYPE_ID, FIELD_TYPE } from '../constants/Constants';
import Config from '../domain/entities/Config';
import TransactionLoadHandler, { ITransactionLoad } from './TransactionLoadHandler';

class SaveNewShippingAddressUseCase extends TransactionLoadHandler {
  private shippingRepository: ShippingRepository;

  private billingRepository: BillingRepository;

  private config: Config;

  private analyticsRepository: AnalyticsRepository;

  private isBillingSameAsShipping: boolean;

  private address: Address;

  constructor(address: Address, isBillingSameAsShipping: boolean, options?: ITransactionLoad) {
    super(options?.transactionLoadOptions);
    this.isBillingSameAsShipping = isBillingSameAsShipping;
    this.address = address;
    this.shippingRepository = diContainer.get(serviceNames.shippingRepository);
    this.billingRepository = diContainer.get(serviceNames.billingRepository);
    this.analyticsRepository = diContainer.get(serviceNames.analyticsRepository);
    this.config = diContainer.get(serviceNames.config);
  }

  public run = async (): Promise<void> => {
    const transaction = await this.transactionRepository.getTransaction();
    const newAddress = await this.shippingRepository.saveNewAddress(this.address);
    // only add new address to billing repository which type is shipping or billing
    // to exclude other address types (e.g. packstation address type = 4)
    const addressType = (
      newAddress.attributes[FIELD_TYPE.ADDRESS_TYPE] || ADDRESS_TYPE_ID.SHIPPING
    ) as ADDRESS_TYPE_ID;
    if ([ADDRESS_TYPE_ID.SHIPPING, ADDRESS_TYPE_ID.BILLING].includes(addressType)) {
      this.billingRepository.addAddress(newAddress);
    }

    transaction.setShippingAddress(newAddress);
    if (this.isBillingSameAsShipping && !this.config.skipBillingAddress) {
      await this.billingRepository.selectAddress(newAddress.id);
      transaction.setBillingAddress(newAddress);
    }
    
    this.analyticsRepository.updateShippingAddressLinkEvent();
  };
}

export default SaveNewShippingAddressUseCase;
